import React, { useEffect, useState } from 'react';
import { Alert, Button, Form } from 'react-bootstrap';
import { useParkingQueueConfig } from '../../hooks/parkingQueue';
import {
    QUEUE_GROUPINGS, QUEUE_GROUPING_LABELS, QUEUE_SORTS, QUEUE_SORT_LABELS, QueueGrouping, QueueSort,
} from '../../types/parkingQueueConfig';

/** Instansinställningar → Parkeringskö: the one standard order the queue is shown in. */
const ParkingQueueSettings: React.FC = () => {
    const { config, loading, saving, error, save } = useParkingQueueConfig();
    const [grouping, setGrouping] = useState<QueueGrouping>(config.grouping);
    const [sort, setSort] = useState<QueueSort>(config.sort);
    const [saved, setSaved] = useState(false);

    useEffect(() => {
        setGrouping(config.grouping);
        setSort(config.sort);
    }, [config]);

    const handleSave = async () => {
        setSaved(false);
        try {
            await save({ grouping, sort });
            setSaved(true);
        } catch {
            // error shown from the hook
        }
    };

    return (
        <div style={{ maxWidth: 560 }}>
            <p className="text-muted">
                Standardordningen är den ordning parkeringskön visas i. Den styr bara visningen och vad som
                räknas som en avvikelse när en plats hyrs ut till någon som inte står först – den stoppar aldrig
                ett hyresavtal.
            </p>
            {error && <Alert variant="danger">{error}</Alert>}
            {saved && <Alert variant="success" onClose={() => setSaved(false)} dismissible>Köordningen är sparad.</Alert>}
            <Form.Group className="mb-3" controlId="parkingQueueGrouping">
                <Form.Label>Gruppering</Form.Label>
                <Form.Select value={grouping} disabled={loading || saving} onChange={e => setGrouping(e.target.value as QueueGrouping)}>
                    {QUEUE_GROUPINGS.map(g => <option key={g} value={g}>{QUEUE_GROUPING_LABELS[g]}</option>)}
                </Form.Select>
            </Form.Group>
            <Form.Group className="mb-3" controlId="parkingQueueSort">
                <Form.Label>Sortering</Form.Label>
                <Form.Select value={sort} disabled={loading || saving} onChange={e => setSort(e.target.value as QueueSort)}>
                    {QUEUE_SORTS.map(s => <option key={s} value={s}>{QUEUE_SORT_LABELS[s]}</option>)}
                </Form.Select>
            </Form.Group>
            <Button variant="primary" onClick={handleSave} disabled={loading || saving}>
                {saving ? 'Sparar…' : 'Spara'}
            </Button>
        </div>
    );
};

export default ParkingQueueSettings;
